import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, finalize, tap } from "rxjs/operators";
import * as CryptoJS from "crypto-js";
import { Router } from '@angular/router';
import { HelperService } from '../helper/helper.service';
import { NotificationService } from '../services/notification.service';
import { AuthService } from 'src/app/modules/auth/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from '../services/common.service';

@Injectable()
export class CommonInterceptor implements HttpInterceptor {

  public message: any;
  public nonce: any = "35A90B73C39D97";
  public path: any;
  public privateKey: any = "4AF8AC8E124B6484BDDC5A9EB3D49";
  public secretKey: any = "PXGuKjNtjzLiyLRE0GzykvGcaZO5uWE0";
  public timestamp: any = 1615971782;
  public accounttype!: any;
  private activeRequests = 0;
  private unauthorized:boolean = false;
  constructor(private commonService:CommonService,private router: Router, private helper: HelperService, private notifyService: NotificationService, private authService: AuthService, private cookieService: CookieService) { }

  intercept(httpRequest: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    //start loader
    if(!httpRequest.url.includes("api/notification") && !httpRequest.url.includes("/api/mquotation/v3/mproject/getprojectByGarberFiles/")){
      this.commonService.updateloadingState(true); // Show loading
      this.activeRequests++;
    }
    //Generate Nonce
    const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
    this.nonce = "";
    for (let i = 0; i < 8; i++) {
      const rnum = Math.floor(Math.random() * chars.length);
      this.nonce += chars.substring(rnum, rnum + 1);
    }
    //Generate TimeStamp
    this.timestamp = Math.floor(new Date().getTime() / 1000);
    let member_token = localStorage.getItem("quote_token");
    let tempacctype = member_token ? '2' : localStorage.getItem("customer_account_type");
    this.accounttype = this.helper.staticPush(tempacctype);

    //Generate TOken
    let generateHmacToken = CryptoJS.HmacSHA256(this.secretKey + this.timestamp + this.nonce, this.privateKey).toString(CryptoJS.enc.Hex);

    const token = member_token ? member_token : localStorage.getItem("customer_access_token");
    let headers = new HttpHeaders()
      .set("nonce", this.nonce.toString())
      .set("timestamp", this.timestamp.toString())
      .set("token", generateHmacToken.toString());
    if (token) {
      headers = headers.set("authorization", token).set("accounttype", this.accounttype);
    }

    const authReq = httpRequest.clone({
      withCredentials: false,
      headers: headers
    });

    httpRequest = authReq;

    return next.handle(httpRequest).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.handleResponse(authReq, event);
        }
      }),
      catchError((error) => {
        this.handleError(httpRequest, error);
        return new Observable<never>();
      }),
      finalize(() => {
        if(!httpRequest.url.includes("api/notification") && !httpRequest.url.includes("/api/mquotation/v3/mproject/getprojectByGarberFiles/")){
          this.activeRequests--;

          if (this.activeRequests < 1) {
            this.activeRequests=0;
            this.unauthorized=false;
            this.commonService.updateloadingState(false);
          }
        }
      })
    );
  }

  async handleResponse(httpRequest: HttpRequest<any>, event: any) {
    if (event instanceof HttpResponse) {
      if (event.body && event.body.code == 401) {
        if(!this.unauthorized){
          this.notifyService.showError("Unauthorized! Sign In again...", "");
          this.unauthorized=true;
        }
        this.helper.Logout();
      } 
      if (event.body && event.body.code == 403) {
        if(!this.unauthorized){
          this.notifyService.showError("Unauthorized! Sign In again...", "");
          this.unauthorized=true;
        }

        this.helper.GetCookieData().then((result:any)=>{

        let data = {
          refreshToken: result.refreshToken
        };
        let resultData = result;
        let eData: any = this.helper.dynamicPush(JSON.stringify(data));

        let reqJSON = {
          data: eData,
        };

        this.authService.CreateNewToken(reqJSON).subscribe((response:any) => {
          if(response.data){
            let res = this.helper.dynamicPop(response.data);
            resultData.accessToken = res.accessToken
            let cookieData = CryptoJS.AES.encrypt(JSON.stringify(resultData), this.helper.GetCookieKey()).toString();
            this.cookieService.delete("customer_user", '/customer');
            this.cookieService.set("customer_user", cookieData);
            localStorage.setItem("customer_access_token", res.accessToken);
            window.location.reload();
          }
        })
      });

      }
    }
  }


  async handleError(httpRequest: HttpRequest<any>, error: any) {
    if (error.status == 0) {
      if(!httpRequest.url.includes("api/notification") && !httpRequest.url.includes("/api/mquotation/v3/mproject/getprojectByGarberFiles/")){
        this.activeRequests=0;
        this.commonService.updateloadingState(false);
      }
      setTimeout(() => {
        this.helper.Logout();
      }, 1000);
    } else if (error.status == 401 || error.status == 404 || error.status == 500) {

      setTimeout(() => {
        this.helper.Logout();
        this.notifyService.showError("Something went wrong!", "");
      }, 1000);
    } else {
      this.notifyService.showError("Something went wrong!", "");
    }
  }
}
